import styled from 'styled-components';
import mainColors from '../../../Style-guide/main-colors';
import sizeStandards from '../../../Style-guide/size-standards';

const MyReservationsWrapper = styled.div`
  padding: 20px;
  text-align: center;

  .reservations-container {
    border: 1px solid ${mainColors.main_color};
    border-radius: 20px;
    margin: 20px auto;
    padding: 12px;
    max-width: 800px;
    width: 100%;
    height: 320px;
    overflow-y: scroll;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  .reservation-item {
    margin-bottom: 12px;
    padding: 4px;
    background-color: ${mainColors.main_color_rgba(0.3)};

    .reservation-time,
    .reservation-actions {
      margin-top: 0;
      display: inline-flex;
      align-items: center;
    }
    .reservation-actions {
      margin-left: 8px;
    }

    .reservation-status {
      font-size: ${sizeStandards.font.XS}px;
      padding: 0 4px;
      border-radius: 20px;
    }

    .status-cancelled {
      color: ${mainColors.error_color};
    }

    .reservation-cancel-button,
    .reschedule-button {
      font-size: ${sizeStandards.font.XS}px;
      padding: 0 6px;
    }

    .reschedule-button {
      margin-left: 0px;
    }
  }
`;

export default MyReservationsWrapper;
